module.exports = __webpack_public_path__ + "static/img/Leonardo-Lombard.4795c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Leonardo-Lombard.jpg
// module id = bpez
// module chunks = 0